import { useMolecule } from "bunshi/react"
import { DropStatusMoleculeReatom } from "./drop-store.reatom"

export function useDropStatusReatom() {
  const statusMolecule = useMolecule(DropStatusMoleculeReatom)

  return statusMolecule
}
